import { useState } from 'react';
import '../App.css';
import Star from '../json/data.json';

export default function History(){

    let hisArr = ['history_1950_00.png', 'history_1950_01.png', 'history_1950_02.png','history_1950_03.png',
                    'history_1960_00.png', 'history_1960_01.png', 'history_1960_02.png','history_1960_03.png',
                    'history_1970_00.png', 'history_1970_01.png', 'history_1970_02.png','history_1970_03.png',
                    'history_1980_00.png', 'history_1980_01.png', 'history_1980_02.png','history_1980_03.png',
                    'history_1990_00.png', 'history_1990_01.png', 'history_1990_02.png','history_1990_03.png',
                ].map( (name, k) => {
                    return <img key={k} src={require(`../img/${name}`).default} alt=""/>
                } );
    let [his, hisChange] = useState(0); //스토리 이미지
    
    let yearArr = ['bg_1950.png','bg_1960.png','bg_1970.png','bg_1980.png','bg_1990.png'].map( (name, k) => {
        return <img key={k} src={require(`../img/${name}`).default} alt=""/>
    } );
    let [ye, yeChange] = useState(0) //연도 이미지
    let [page, setPage] = useState(1) //페이지 번호

    function next(){
        if(his<hisArr.length-1){
            hisChange(his+1)
            setPage(page+1)
            switch (page) {
                case 4 : yeChange(1); break;
                case 8 : yeChange(2); break;
                case 12 : yeChange(3); break;
                case 16 : yeChange(4); break;
            }
        }else{
            hisChange(0)
            setPage(1)
            yeChange(0)
        }
    }
    function prev(){
        hisChange(his-1)
        setPage(page-1)
        switch (page) {
            case 5 : yeChange(0); break;
            case 9 : yeChange(1); break;
            case 13 : yeChange(2); break;
            case 17 : yeChange(3); break;
            case 20 : yeChange(4); break;
        }
        if( his == 0 ){
            hisChange(19)
            setPage(20)
            yeChange(4)
        }
    }
    function move1(){ hisChange(0); setPage(1); yeChange(0) }
    function move2(){ hisChange(4); setPage(5); yeChange(1) }
    function move3(){ hisChange(8); setPage(9); yeChange(2) }
    function move4(){ hisChange(12); setPage(13); yeChange(3) }
    function move5(){ hisChange(16); setPage(17); yeChange(4) }


    // 표
    let subject = [];
    for(let tit in Star.TITLE){
        subject.push(Star.TITLE[tit])
    }

    let [data, setData] = useState(Star.HISTORY);
    function dayChange(e){
        setData(
            Star.HISTORY.filter(day => (
                day['year'] == e.target.value
            ))
        );
        const form = document.querySelector('.history table');
        form.style.width = '800px'
    }

    let hisImg =[];

    Star.HISTORY.map( (img,k) => ( // 기본 사진
        hisImg.push(img['img'])
    ))
    return(
        <>
            <section className="seven">
                <h2>많은 사람들이 함께한<br/><b>칠성사이다,</b> 70년의 추억</h2>
                <div>
                    <p>{hisArr[his]}</p>
                    <p>{yearArr[ye]}</p>
                    <button onClick={move1}>1950</button>
                    <button onClick={move2}>1960</button>
                    <button onClick={move3}>1970</button>
                    <button onClick={move4}>1980</button>
                    <button onClick={move5}>1990</button>
                </div>
                <p>
                    <button onClick={prev}></button>
                    <strong>{page} / 20</strong>
                    <button onClick={next}></button>
                </p>
            </section>
            <section className="history">
                <h2>반세기 이상의 역사를 지닌<br/><b>칠성사이다 Design History</b></h2>
                <div>
                    <select id='day' onChange={dayChange}>
                        {
                            Star.HISTORY.map( (data,k) => (
                                <option key={k}>{data['year']}</option>
                            ))
                        }
                    </select>
                </div>
                <table>
                    <thead>
                        <tr>
                            {
                                subject.map((tit,k) => (
                                    <th key={k}>{tit}</th>
                                ))
                            }
                        </tr>
                    </thead>
                    <tbody>
                            {
                                data.map( (data,k) =>(
                                    <tr key={k} >
                                        <td>{data['year']}</td>
                                        <td>
                                            <img src={require(`../img/${data['img']}`).default} alt=""/>
                                        </td>
                                        <td>{data['detail']}</td>
                                    </tr>
                                ))
                            }
                    </tbody>
                </table>
            </section>
        </>
    )
}